import * as Cesium from 'cesium'
export class CameraController {
  viewer
  private readonly MIN_CAMERA_HEIGHT = 300 // 设置最小相机高度为300米

  constructor(viewer: Cesium.Viewer) {
    this.viewer = viewer
    this.setupCameraLimits()
  }

  private setupCameraLimits() {
    // 添加相机移动事件监听
    this.viewer.scene.camera.moveEnd.addEventListener(() => {
      const currentHeight = this.getCameraHeight()
      if (currentHeight < this.MIN_CAMERA_HEIGHT) {
        // 如果低于最小高度，则设置回最小高度
        const cartographic = Cesium.Cartographic.fromCartesian(this.viewer.camera.position)
        const surface = Cesium.Cartesian3.fromRadians(
          cartographic.longitude,
          cartographic.latitude,
          this.MIN_CAMERA_HEIGHT
        )
        this.viewer.camera.setView({
          destination: surface,
          orientation: {
            heading: this.viewer.camera.heading,
            pitch: this.viewer.camera.pitch,
            roll: this.viewer.camera.roll,
          },
        })
      }
    })

    // 限制缩放
    this.viewer.scene.screenSpaceCameraController.minimumZoomDistance = this.MIN_CAMERA_HEIGHT
  }

  // 获取当前视口信息并保存到变量
  getCurrentView() {
    const camera = this.viewer.camera
    return {
      position: camera.position.clone(),
      heading: camera.heading,
      pitch: camera.pitch,
      roll: camera.roll,
    }
  }

  // 恢复视角到指定视口信息
  restoreView(savedView: ReturnType<typeof this.getCurrentView>) {
    const { position, ...orientation } = savedView
    this.viewer.camera.setView({
      destination: position,
      orientation: orientation,
    })
  }

  // 获取相机高度
  getCameraHeight() {
    const position = this.viewer.camera.position
    const cartographic = Cesium.Cartographic.fromCartesian(position)
    return cartographic.height
  }

  overlook(coord: { lat: number; lng: number }, range = 10000) {
    const offset = new Cesium.HeadingPitchRange(
      0, // 朝向（Heading），0表示正北方向
      Cesium.Math.toRadians(-90), // 俯仰（Pitch），-90度表示俯视
      Math.max(range, this.MIN_CAMERA_HEIGHT) // 确保不小于最小高度
    )
    this.viewer.camera.flyTo({
      destination: Cesium.Cartesian3.fromDegrees(
        coord.lng,
        coord.lat,
        Math.max(range, this.MIN_CAMERA_HEIGHT)
      ),
      orientation: {
        heading: offset.heading,
        pitch: offset.pitch,
        roll: 0,
      },
    })
  }
}
